import axios from 'axios';
import store from '@/store/Store';

// @ts-ignore
const API_URL = import.meta.env.VITE_API_URL;

export const fetchSiivousTila = async (id, date) => {
  const token = store.getState().auth.token;

  if (!token) throw new Error('Not authenticated!');

  const res = await axios.get(`${API_URL}/siivous/tila?id=${id}&date=${date}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (res.status !== 200) {
    throw new Error('Siivoustilan hakeminen epäonnistui!');
  }

  return res.data;
};

export const updateAsSiivottu = async (id) => {
  const token = store.getState().auth.token;

  if (!token) throw new Error('Not authenticated!');

  const res = await axios.post(`${API_URL}/siivous/${id}/siivottu`, {}, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (res.status !== 200) {
    throw new Error('Siivoustilan päivittäminen epäonnistui!');
  }
};

export const updateAsSiivoamatta = async (id) => {
  const token = store.getState().auth.token;

  if (!token) throw new Error('Not authenticated!');

  const res = await axios.delete(`${API_URL}/siivous/${id}/siivottu`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (res.status !== 200) {
    throw new Error('Siivoustilan päivittäminen epäonnistui!');
  }
};
